import { PermissionT } from "../types";

export const reportsView = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "reports_view");
  return !!p;
};

export default reportsView;
